import { PaneArea } from '../../types/shared'
import Position, { IPositionAttrs } from '../canvas/position'
import PaneModel from '../models/pane'

type Area = PaneArea
type Attrs = IPositionAttrs
type PartialAttrs = Partial<Attrs>

class PositionCreator extends Position<Attrs & Pick<IPositionAttrs, 'targetY' | 'centerY' | 'stopY'>> {
  mouseDowns = 1
  isCreator = true

  constructor(startArea: Area, values: PartialAttrs, model: PaneModel, _: unknown, toolsCallback: () => void) {
    super(
      {
        ...values,
        targetY: startArea.y,
        centerY: startArea.y,
        stopY: startArea.y,
      },
      model
    )

    this.attrs.x1 = this.attrs.x2 = Math.round(startArea.x)
    this.toolsCallback = toolsCallback

    window.gtag?.('event', 'create', { event_category: 'tools', event_label: this.name })
  }

  onMouseDown() {
    this.mouseDowns++
    if (this.mouseDowns === 2) {
      if (this.attrs.targetY <= this.attrs.centerY) {
        this.attrs.stopY = this.attrs.centerY + 0.001
      } else {
        this.attrs.stopY = this.attrs.centerY - 0.001
      }
    }
    if (this.mouseDowns > 2) {
      this.release()
      this.replaceMyself(Position.fromObject<Position>(this.attrs, this.model))
      this.toolsCallback()
    }
  }

  onMouseMove(area: Area) {
    const { stopY, centerY } = this.attrs
    if (this.mouseDowns === 1) {
      this.attrs.centerY = this.attrs.stopY = area.y
    } else if (this.mouseDowns === 2) {
      if ((stopY >= centerY && area.y > centerY) || (stopY <= centerY && area.y < centerY)) {
        this.attrs.stopY = area.y
      }
    }
    this.attrs.x2 = Math.round(area.x)
    this.trigger('change')
  }
}

export default PositionCreator
